import { render } from "./list_search.vue?vue&type=template&id=1621a149"
import script from "./list_search.vue?vue&type=script&lang=js"
export * from "./list_search.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/oralhealthmap.uz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__